import React from "react";
import ReactDOM from "react-dom";

interface Props {
  children: any;
}

const Modal: React.FC<Props> = React.memo((props) => {
  const [container, setContainer] = React.useState(null);

  React.useEffect(() => {
    const innerContainer = document.createElement("div");

    innerContainer.classList.add("modal-container");
    document.body.appendChild(innerContainer);

    // @ts-expect-error TS2345
    setContainer(innerContainer);

    return () => {
      try {
        document.body.removeChild(innerContainer);
      } catch (e) {
        console.error(e);
      }
    };
  }, []);

  if (!container) return null;

  return ReactDOM.createPortal(props.children, container);
});

export default Modal;
